<div class="eui-common-header__label">
    <div class="eui-common-header__label-text" attr.aria-label="{{label}}">{{label}}</div>
    <div class="eui-common-header__actions">
        <ng-content></ng-content>
    </div>
</div>
<div *ngIf="subLabel" class="eui-common-header__sub-label" [class.eui-common-header__sub-label--collapsed]="isCollapsed" attr.aria-label="{{subLabel}}">
    <div class="eui-common-header__sub-label-text" >{{subLabel}}</div>
</div>
